import { createContext, useContext } from 'react';

import type { ActivityComposerHandle } from 'src/components';

/**
 * The task composer's unsent draft, which a review action's dialog starts its note from. Null
 * outside a task panel, or while the composer writes to the team-only lane, whose text must not
 * reach the people a review action notifies.
 */
export const TaskComposerDraftContext = createContext<ActivityComposerHandle | null>(null);

/** Optional by design: a dialog outside a task panel starts with an empty note. */
export function useTaskComposerDraft(): ActivityComposerHandle | null {
  return useContext(TaskComposerDraftContext);
}
